import React from "react";
import "../../style/Hero.css";

function Hero() {
  const handleTimelineClick = () => {
    const section = document.getElementById("timeline");
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="hero">
      <div className="hero-overlay">

        {/* Removed Logo Section */}
        <div className="hero-content">
          <h1> Welcome to International Conference <br /> 2026</h1>
          <h2 className="subtitle">Emerging Trends and Innovations in Engineering, Management, and Technology<br /> Friday, 24th April, 2026 and Saturday, 25th April, 2026</h2>
          <p className="organized-by">Organized by<br /> IITM College of Engineering</p>

          <div className="action-buttons">
            <button className="action-btn" onClick={handleTimelineClick}>
              Timeline
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
